<template>
  <div>
    <Head title="Tambah Universitas" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/universities">Universitas</Link>
      <span class="font-medium text-indigo-400">/</span> Tambah Data
    </h1>
    <div class="w-full overflow-hidden bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <text-input v-model="form.nama" :error="form.errors.nama" class="w-full pb-8 pr-6 lg:w-1/2" label="Nama Universitas" />
          <text-input v-model="form.kode_pt" :error="form.errors.kode_pt" class="w-full pb-8 pr-6 lg:w-1/2" label="Kode PT" />
          <text-input v-model="form.url" :error="form.errors.url" class="w-full pb-8 pr-6 lg:w-1/2" label="Alamat Website" />
          <text-input v-model="form.alamat" :error="form.errors.alamat" class="w-full pb-8 pr-6 lg:w-1/2" label="Alamat" />

          <select-input
            v-model="form.status" :error="form.errors.status" class="w-full pb-8 pr-6 lg:w-1/2"
            label="Jenis Perguruan Tinggi"
          >
            <option value="PTN">PTN</option>
            <option value="PTKL">PTKL</option>
            <option value="PTNL">PTN Lokal</option>
            <option value="PTS">PTS</option>
            <option value="-">-</option>
          </select-input>
          <div class="flex w-full pb-8 pr-6 lg:w-1/2">
            <input id="mou" v-model="form.is_mou" type="checkbox" class="mr-2" />
            <label for="mou" class="flex flex-row items-center cursor-pointer">
              Sudah Kerja Sama (MoU)
            </label>
          </div>
          <div class="flex w-full pb-8 pr-6 lg:w-1/2">
            <input id="id_active" v-model="form.is_active" type="checkbox" class="mr-2" />
            <label for="id_active" class="flex flex-row items-center cursor-pointer">
              Tampilkan di sistem (Active)
            </label>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 border-t border-gray-100 bg-gray-50">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '../../Shared/SelectInput.vue'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    SelectInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nama: null,
        kode_pt: null,
        url: null,
        alamat: null,
        is_mou: false,
        is_active: false,
        status: false,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('universities.store'))
    },
  },
}
</script>
